/**
 * @module app.bdc.list.abandonedOrderCtrl
 *
 */
define(['angular'], function(angular) {


    function AbandonedOrderCtrl($scope, $uibModalInstance) {
        var self = {};

        self.abandoned = function() {
            $uibModalInstance.close(true);
        };

        self.doNotAbandoned = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    AbandonedOrderCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular.module('app.bdc.list.abandonedOrderCtrl', ['ui.bootstrap.modal']).controller('AbandonedOrderCtrl', AbandonedOrderCtrl);
});
